import { IDs } from '../../../helpers/IDs';

export function findSteuerParameter(data: any, jahr: number) {

    let found: any = undefined;
    const data_steuer = data[IDs.ENT_PARAMETER_ENERGIESTEUER] || [];
    data_steuer.forEach((item: any) => {
        // Wir suchen das höchste Jahr, welches maximal dem gesuchten Jahr entspricht
        if (!found) {
            found = item;
        } else
            if (item.jahr <= jahr && item.jahr > found.jahr) {
                found = item;
            }
    });
    return found;
}
